import React from 'react';
import {
    Flex,
    Text,
    Heading,
    Button,
    Divider
} from '@chakra-ui/react';

const PricingCard = ({ title, subtitle, price, features, recomended, ...props }) => {
    return (
        <Flex
            bg={'#fefefe'}
            flexDirection={{
                base: 'row',
                md: 'column',
            }}
            borderRadius={'lg'}
            w={{
                base: '100%',
                md: '30%',
            }}
            flex={1}
            zIndex={1}
            position={'relative'}
            shadow={'md'}
            cursor={'pointer'}
            p={5}
            {...props}
        >
            <Flex flex={1}>
                {recomended && (
                    <Flex
                        p={2}
                        h={5}
                        bg={'blue.500'}
                        borderRadius={'full'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'absolute'}
                        top={-1}
                        left={-2}
                    >
                        <Text color={'white'} fontSize={'xs'} fontWeight={'bold'}>
                            Recomendado
                        </Text>
                    </Flex>
                )}
                <Flex w='100%' flexDir='column' justifyContent='space-between'>
                    <Heading as="h1" size="md" mt={0}>
                        {title}
                    </Heading>
                    <Text mt={2} fontSize='sm' color='gray.500' >
                        {subtitle}
                    </Text>
                    <Text  
                        fontWeight='bold'
                        mt={2} fontSize='sm' >
                        {price}
                    </Text>
                    <Divider my={5} />
                    <Flex flexDir='column' mb={5}>
                        {features.map((feature, index) => (
                            <Text key={index} fontSize='sm' >
                                - {feature}
                            </Text>
                        ))}
                    </Flex>
                    <Button w='100%' size='sm' colorScheme='blue' >
                        Contactar
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
}

export default PricingCard;